import styled from 'styled-components';
import Href from '@sdk/components/ui/Href';

export const CheckboxLabel = styled(Href)`
  font-size: ${({ theme }): string => theme.fontSizes.l};
  color: ${({ theme }): string => theme.colors.iconGray};
  padding-left: 5px;
  user-select: none;

  &:hover {
    text-decoration: none;
  }
`;
